import React from 'react'
import withAppdata from '../AppConfig/withAppdata'
import { unseenCount } from '../utils/cintoiaEvents'

// The Cintoia Events menu badge: items published since the user last opened the page
// (userpreferences.eventsseen, saved by CintoiaEventsContainer).
function EventsBadge({ appdata }) {
  if (!appdata) return null
  const seen = appdata.userpreferences ? appdata.userpreferences.eventsseen : undefined
  const count = unseenCount(appdata.events || [], seen)
  if (!count) return null
  return (
    <span className='sidebar-count' aria-label={count + ' uutta'}>
      {count}
    </span>
  )
}

export default withAppdata(EventsBadge)
